export default __webpack_public_path__ + "static/media/adam-shaffir.ed66ab81.png";